import {  DECREMENT, INCREMENT } from "./actiontypes";

const initialState = [
    {
        id:0,
        name:'Asus Vivobook X515MA',
        inCart:0,
        inStock:20,
        price:35500
    },
    {
        id:1,
        name:'Dell E1916HV 18.5 Inch',
        inCart:0,
        inStock:35,
        price:9300
    },
    {
        id:2,
        name:'Canon Eos 4000D 18MP',
        inCart:0,
        inStock:72,
        price:36500
    },
];

const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case INCREMENT:
            let updatedArr1 = [...state].map((x)=>  {
                if( x.id === action.payload) {
                  x.inCart=x.inCart+1;
                  x.inStock=x.inStock-1;
                  return x;
                }  
                return x;
              } );
              
            return updatedArr1

        case DECREMENT:
            let updatedArr2 = [...state].map((x)=>  {
                if( x.id === action.payload) {
                  x.inCart=x.inCart-1;
                  x.inStock=x.inStock+1;
                  return x;
                }  
                return x;
              } );
            return updatedArr2

        default:
            return state;
    }
};

export default cartReducer;
